export class WithholdingType {
    
    id: number = 0;
    code!: string;
    description!: string;
    
}